export default {
  "pendingReview": "待审核",
  "approved": "已通过",
  "rejected": "已拒绝",
  "couldNotLoadMembershipApplications": "读取入会申请失败",
  "couldNotLoadApplicationDetails": "读取申请详情失败",
  "approve": "通过",
  "reject": "拒绝",
  "membershipApplications": "入会申请",
  "membershipApplications1": "💡 入会申请阶段",
  "doNotIncurFees": "不产生任何费用",
  "paymentMethodsAndStatusesAreTherefore": "，因此列表中没有缴费方式与缴费状态列；审核通过并正式入会后，才会按「会费设置」的规则生成应缴单（见「续费管理」）。每条申请会记录",
  "applicationTerm": "申请届别",
  "forArchivingAndReportingByTerm": "，便于按届归档与统计。",
  "switchTabsToViewApplicationsBy": "左右切换查看不同会员类型的入会申请",
  "all": "全部",
  "searchRegistrationDetails": "搜索登记信息",
  "search": "搜索",
  "status": "状态",
  "reviewer": "审核人",
  "appliedAt": "申请时间",
  "actions": "操作",
  "viewDetails": "查看详情",
  "membershipApplicationDetails": "入会申请详情",
  "reviewStatus": "审核状态",
  "close": "关闭",
  "paid": "已缴",
  "pendingPayment": "待缴",
  "overdue": "逾期",
  "name": "姓名",
  "enterAName": "请输入姓名",
  "avatar": "头像",
  "phoneNumber": "手机号",
  "enterAContactNumber": "请输入联系电话",
  "level": "级别",
  "couldNotLoadData": "加载失败",
  "uploadAJPGPNGOrWEBP": "请上传 10MB 以内的 JPG、PNG 或 WEBP 图片",
  "imageUploaded": "图片上传成功",
  "couldNotUploadImage": "图片上传失败",
  "selectAMemberType": "请选择会员类型",
  "couldNotDownloadTemplate": "模板下载失败",
  "membersCsv": "会员名单.csv",
  "couldNotExportData": "导出失败",
  "selectAMemberTypeFirst": "请先选择会员类型",
  "uploadAnXlsxOrXlsFile": "请上传 .xlsx 或 .xls 文件",
  "couldNotReadTemplate": "模板解析失败",
  "selectAFileToImport": "请选择导入文件",
  "couldNotImportMembers": "导入失败",
  "enterANameAndPhoneNumber": "请填写姓名和手机号",
  "saved": "已保存",
  "couldNotSaveChanges": "保存失败",
  "deleteTheSelectedMembers": "确认删除选中会员？",
  "delete": "删除",
  "couldNotDelete": "删除失败",
  "memberList": "会员列表",
  "importInstructions": "⚠️ 导入须知：",
  "1UseTheQuickImportTemplate": "1. 导入会员只能使用快速模版导入，",
  "downloadQuickImportTemplate": "下载快速导入模版",
  "toImportMembers": "，进行会员导入",
  "addMember": "+ 添加会员",
  "refresh": "刷新",
  "edit": "编辑",
  "exportMembers": "导出会员",
  "downloadQuickImportTemplate2": "下载快速导入模板",
  "importMembers": "导入会员",
  "paymentStatus": "缴费状态",
  "type": "类型",
  "organizationName": "所属名称",
  "positionLevel": "职务/级别",
  "placeOfOrigin": "籍贯",
  "industry": "行业分类",
  "term": "届别",
  "joinedIn": "入会于",
  "joinedOn": "入会时间",
  "expiresOn": "到期时间",
  "paymentMethods": "缴费方式",
  "active": "正常",
  "hidden": "隐藏",
  "addedAt": "添加时间",
  "editMember": "编辑会员",
  "addMember3": "添加会员",
  "linkedWeChatUser": "关联微信用户",
  "selectARegisteredWeChatUserWho": "选择已注册、未成为会员的微信用户",
  "memberType": "会员类型",
  "visible": "显示",
  "pleaseSelect": "请选择",
  "uploading": "上传中…",
  "cancel": "取消",
  "save": "保存",
  "downloadTemplate": "下载模板",
  "importFile": "导入文件",
  "uploadExcelTemplate": "上传 Excel 模板",
  "useTheDownloadedXlsxTemplatePhone": "请使用下载的 .xlsx 模板；手机号按文本读取并用于匹配微信用户和会员资料。",
  "confirmImport": "确认导入",
  "memberShowcaseSettingsSaved": "会员风采设置已保存",
  "memberShowcase": "会员风采",
  "viewMemberList": "查看会员列表",
  "memberShowcaseIsTheMiniProgram": "会员风采是小程序端向会员展示的通讯录页面（会员列表 + 会员详情）。本页只维护它的可见性权限；会费与届期规则见",
  "feeSettings": "会费设置",
  "forPaymentChannelsAndBankAccounts": "，缴费渠道与对公账号见",
  "configureDirectoryAccessMemberDetailVisibility": "配置会员风采（小程序端会员通讯录）的对外开放范围、会员详情显示权限与排序方式。点击页面底部【保存设置】后对会员端生效。",
  "publicDirectoryAccess": "通讯录是否对外开放",
  "yes": "是",
  "no": "否",
  "whenEnabledEveryoneCanViewThis": "备注：开放表示端的所有人可以查看该组织的通讯录",
  "memberDetailAccess": "会员详情显示权限",
  "partiallyPublic": "部分开放",
  "fullyPublic": "全部开放",
  "membersOnly": "会员专属",
  "partiallyPublicEveryoneCanViewThe": "部分开放：所有人可看会员列表；仅正式会员可看会员详情；",
  "fullyPublicEveryoneCanViewThe": "全部开放：所有人可看会员列表和会员详情；",
  "membersOnlyOnlyEnrolledMembersCan": "会员专属：仅正式会员可看会员列表和会员详情",
  "directorySorting": "通讯录排序方式",
  "byPinyin": "拼音排序",
  "byDistrict": "区县排序",
  "byPosition": "职务排序",
  "saveSettings": "保存设置",
  "onlinePaymentsEnabled": "线上缴费已启用",
  "onlinePaymentsDisabled": "线上缴费已关闭",
  "couldNotUpdateSettings": "更新失败",
  "alipayWillBeAvailableWhenPayment": "支付宝渠道将在支付配置接入后可用",
  "couldNotUpdatePaymentChannel": "渠道更新失败",
  "enterTheAccountHolderBankAnd": "启用线下缴费前请填写收款户名、开户银行和银行账号",
  "offlinePaymentsEnabled": "线下缴费已启用",
  "offlinePaymentsDisabled": "线下缴费已关闭",
  "couldNotSaveBankAccount": "对公账号保存失败",
  "bankAccountCopied": "银行账号已复制",
  "couldNotCopyCopyTheDetails": "复制失败，请手动复制",
  "viewPaymentRecords": "查看缴费记录",
  "chooseThePaymentMethodsAvailableTo": "缴费方式决定会员在小程序端缴纳会费时可选择的渠道，两种方式可同时启用；已关闭的方式不会展示给会员。线下缴费需维护对公转账账号，会员按此账号转账并上传凭证，由协会管理员审核确认后入账。本页改动即时生效，无需保存。",
  "onlinePayments": "线上缴费",
  "enabled": "启用",
  "membersPayDirectlyInTheMini": "会员在小程序内直接支付会费，支付成功后自动入账并生成缴费记录。",
  "paymentChannels": "支付渠道",
  "weChatPay": "微信支付",
  "alipay": "支付宝",
  "onlinePaymentsRequireAnActiveMerchant": "线上收款依赖「小程序配置 → 支付配置」中已开通的商户号；未开通时会员端不会展示线上缴费入口。",
  "configurePayments": "去配置支付",
  "offlinePayments": "线下缴费",
  "membersTransferFeesToABank": "会员通过对公银行账户缴纳会费并上传转账凭证，由管理员在后台审核确认后入账。",
  "bankTransferAccount": "对公转账账号",
  "copyBankAccount": "复制银行账号",
  "accountHolder": "收款户名",
  "enterTheAccountHolder": "请输入收款户名",
  "bankIncludingBranch": "开户银行（含支行）",
  "enterTheBankName": "请输入开户银行",
  "accountNumber": "银行账号",
  "enterTheAccountNumber": "请输入银行账号",
  "transferReference": "转账附言",
  "eGMembershipFeeMemberName": "如：会费 + 会员姓名",
  "memberInstructionsTransferFundsToThis": "会员端提示：请将款项转入以上对公账户，转账后上传凭证，管理员核对到账后完成入账。",
  "thisMethodIsDisabledAccountDetails": "当前方式已关闭，以上账号不会展示给会员。",
  "paid4": "已支付",
  "refunded": "已退款",
  "rejected5": "已驳回",
  "unpaid": "未支付",
  "bankTransfer": "对公转账",
  "confirmReceipt": "确认到账",
  "confirmApproval": "确认通过",
  "paymentReceiptConfirmed": "已确认到账",
  "actionFailed": "操作失败",
  "provideARejectionReasonTheMember": "请填写驳回原因，会员可重新上传凭证",
  "rejectOfflinePayment": "拒绝线下缴费",
  "confirmRejection": "确认拒绝",
  "eGUnclearReceiptIncorrectAmount": "例如：凭证不清晰 / 金额不符 / 未查到到账",
  "enterARejectionReason": "请填写驳回原因",
  "paymentRecordsCsv": "缴费记录.csv",
  "paymentRecords": "缴费记录",
  "export": "导出",
  "totalCollected": "累计收缴",
  "paymentsRecorded": "笔已入账",
  "outstandingAmount": "待收金额",
  "membersAwaitingPayment": "人待缴纳",
  "refundCount": "退款笔数",
  "totalRecords": "记录总数",
  "paymentRecords6": "条缴费记录",
  "searchOrderNumberNicknameName": "搜索订单号 / 昵称 / 姓名",
  "allLevels": "全部级别",
  "allStatuses": "全部状态",
  "allPaymentMethods": "全部支付方式",
  "thisYear": "本年度",
  "allYears": "全部年份",
  "noPaymentRecords": "暂无缴费记录",
  "orderNumber": "订单号",
  "nickname": "昵称",
  "membershipLevel": "入会级别",
  "membershipFee": "会费",
  "paymentStatus7": "支付状态",
  "paidAt": "缴费时间",
  "paymentReceipt": "缴费凭证",
  "view": "查看",
  "createdAt": "创建时间",
  "total": "共",
  "recordsPaid": "条记录 · 已支付",
  "unpaid8": "笔 · 未支付",
  "rejected9": "笔 · 已驳回",
  "refunded10": "笔 · 已退款",
  "payments": "笔",
  "noReceiptImage": "暂无凭证图片",
  "enterAMemberType": "请填写会员类型",
  "couldNotLoadMemberTypes": "会员类型列表加载失败",
  "memberTypeUpdated": "会员类型已更新",
  "memberTypeAdded": "会员类型已新增",
  "couldNotSaveMemberType": "会员类型保存失败",
  "deleteMemberType": "删除会员类型",
  "memberTypeDeleted": "会员类型已删除",
  "couldNotDeleteMemberType": "会员类型删除失败",
  "types": "个类型",
  "addMemberType": "+ 新增会员类型",
  "applicantsChooseAMemberTypeAnd": "申请人在小程序端先选择会员类型，再填写该类型的入会登记字段。可在此新增、编辑、删除类型及配置登记字段；档位系数请在「会费设置 → 会员类型费率」中维护。",
  "registrationFields": "所用到的字段",
  "couldNotLoadFieldsReopenThe": "登记字段加载失败，请重新打开配置",
  "fieldsIncluding": "项字段，其中必填",
  "requiredIndicatesRequired": "项 · 带 * 为必填",
  "configureRegistrationFields": "入会登记字段配置",
  "noMemberTypesYetAddOne": "暂无会员类型，请新增",
  "editMemberType": "编辑会员类型",
  "addMemberType11": "新增会员类型",
  "eGCorporateMember": "如：企业会员",
  "description": "说明",
  "memberTypeDescription": "会员类型说明",
  "newTypesHaveADefaultMultiplier": "新增类型的档位系数默认为 1，可在会费设置中统一调整。",
  "text": "文本字段",
  "shortTextSuchAsNamesTitles": "适合名称、标题、电话等短文本",
  "multilineText": "文本域",
  "longTextSuchAsIntroductionsAnd": "适合简介、说明等多行文本",
  "number": "数字字段",
  "numericValuesSuchAsQuantities": "适合填写数量等数字信息",
  "date": "日期字段",
  "selectADate": "选择年月日",
  "singleChoice": "单选按钮",
  "selectOneOption": "从多个选项中选择一项",
  "multipleChoice": "复选按钮",
  "selectMultipleOptions": "支持同时选择多个选项",
  "dropdown": "下拉列表",
  "selectFromADropdown": "通过下拉列表选择选项",
  "imageUpload": "图片上传",
  "uploadAvatarsLogosAndOtherImages": "上传头像、Logo等图片",
  "time": "时间字段",
  "selectATime": "选择时分",
  "dateAndTime": "日期时间",
  "selectADateAndTime": "选择日期和时间",
  "basicFields": "基础题型",
  "commonFields": "常用题库",
  "introduction": "介绍",
  "address": "所在地址",
  "position": "职务",
  "advancedFields": "高级题型",
  "option1": "选项一",
  "option2": "选项二",
  "image": "图片",
  "couldNotLoadRegistrationFields": "登记字段加载失败",
  "upTo100FieldsAreAllowed": "最多配置100个字段",
  "option1Option2": "选项一,选项二",
  "enterAMemberTypeName": "请填写会员类型名称",
  "enterAFieldLabel": "请填写字段的标签名称",
  "memberTypeAndRegistrationFieldsAdded": "会员类型及登记字段已新增",
  "registrationFieldSettingsSaved": "登记字段设置已保存",
  "couldNotSaveRegistrationFields": "登记字段保存失败",
  "memberTypeName": "会员类型名称",
  "eGCouncilOrganizationMember": "如：理事单位会员",
  "newTypesAlsoAppearUnderFee": "新增后同步到「会费设置 → 会员类型费率」；档位系数与说明可在会费设置里面调整。",
  "fieldsMarkedAreRequiredSeparateOptions": "提示：带 * 的为必填项，会员必须填写后才能提交；单选、多选、下拉类型的多个配置项之间请用英文逗号“,”分割。",
  "registrationInformation": "登记信息",
  "configureTheFieldsMembersCompleteDuring": "入会登记时向会员展示并收集的字段。点击左侧「题型 / 常用题库」添加字段，点选中间任意字段即可在右侧编辑它的标签、类型与展示规则。",
  "dragToReorder": "拖动排序",
  "untitledField": "未命名字段",
  "hiddenOnEnrollment": "入会不展示",
  "moveFieldUp": "上移字段",
  "moveFieldDown": "下移字段",
  "duplicateField": "复制字段",
  "deleteField": "删除字段",
  "fromPositionsAndBaseAnnualFees": "从“职务与基准年费”获取",
  "addField": "＋ 添加字段",
  "fieldProperties": "字段属性",
  "fieldLabel": "标签名称",
  "nameShownOnTheMembershipRegistration": "会员登记表单上显示的名称。",
  "fieldType": "字段类型",
  "required": "是否必填",
  "aRedMarksThisFieldAs": "开启后表单中会出现红色 *，会员必须填写才能提交。",
  "showOnEnrollment": "入会是否展示",
  "whenDisabledThisFieldIsHidden": "关闭后该字段不会出现在入会登记表单中。",
  "showInDetails": "详情是否展示",
  "whenDisabledThisFieldIsHidden12": "关闭后该字段不会展示在会员详情页。",
  "placeholderOptions": "提示信息 / 配置项",
  "separateOptionsWithCommas": "选项用英文逗号分隔",
  "placeholder": "提示信息",
  "optionsFollowThePositionAndBase": "选项随职务与基准年费设置同步。",
  "grayPlaceholderTextForChoiceAnd": "输入框内的灰色提示文字；单选 / 复选 / 下拉字段请在此填写配置项，多个之间用英文逗号“,”分割。",
  "thisSystemFieldIsMandatoryIt": "该字段为系统强制必填字段，不可删除，也不可关闭「是否必填」。",
  "thisSystemFieldCannotBeDeleted": "该字段为系统固定字段，不可删除或修改名称、类型；可调整是否必填和详情展示。",
  "addAFieldFromTheLeft": "从左侧「题型 / 常用题库」点击即可添加字段；",
  "orSelectAFieldInThe": "或在中间表单里点选某个字段，",
  "toEditItsLabelTypeAnd": "就能在这里编辑它的标签、类型与展示规则。",
  "enabled13": "启用状态：",
  "disabled": "禁用",
  "showAndEnable": "备注：是否展示启用",
  "newMemberType": "新会员类型",
  "message1": "确认{p0}这条入会申请？该操作仅更新申请状态。",
  "message2": "{p0}申请",
  "message3": "申请已{p0}",
  "message4": "{p0}失败",
  "message5": "已解析 {p0} 条会员资料",
  "message6": "导入完成：新增 {p0} 条，更新 {p1} 条",
  "message7": "上传{p0}",
  "message8": "收款户名：{p0}",
  "message9": "开户银行：{p0}",
  "message10": "银行账号：{p0}",
  "message11": "转账附言：{p0}",
  "message12": "确认「{p0}」的线下转账已到账？通过后将记为已支付并开通会籍。",
  "message13": "确认删除「{p0}」？其入会登记字段也将删除。",
  "message14": "请上传{p0}",
  "message15": "请选择{p0}",
  "message16": "请输入{p0}",
  "message17": "{p0}（副本）",
  "message18": "入会登记字段配置 · {p0}",
  "message19": "{p0}信息",
  "currentTerm": "当前届别",
  "joinedTerm": "入会届别",
  "profileData": "资料",
  "feeCny": "会费(元)",
  "hasReceipt": "是否有凭证",
  "online": "线上",
  "offline": "线下",
  "free": "免费",
  "templateSheet": "会员导入模板",
  "templateFilename": "会员导入模板.xlsx",
  "emptyImport": "模板中没有可导入的数据",
  "phoneColumnRequired": "模板必须包含“手机号”列",
  "missingPhone": "第 {row} 行缺少手机号",
  "approvedSuccess": "申请已通过",
  "rejectedSuccess": "申请已拒绝",
  "applicationHint": "💡 入会申请阶段不产生任何费用，因此列表中没有缴费方式与缴费状态列；审核通过并正式入会后，才会按「会费设置」的规则生成应缴单（见「续费管理」）。每条申请会记录申请届别，便于按届归档与统计。",
  "paymentSummary": "共 {total} 条记录 · 已支付 {paid} 笔 · 未支付 {unpaid} 笔 · 已驳回 {rejected} 笔 · 已退款 {refunded} 笔",
  "paymentOff": "关闭",
  "sentenceEnd": "。"
}
